/**
 * 意大利语
 */
var itIT = {
  locale: 'it-IT',
  Common: {
    pleaseInput: 'Si prega di inserire',
    pleaseSelect: 'Si prega di selezionare',
    confirm: 'Confermare',
    clear: 'Cancellare',
    cancel: 'Annullare',
    next: 'Avanti',
    previous: 'Precedente',
    submit: 'Invia',
    reset: 'Ripristina'
  },
  Exception: {
    emptyData: 'Nessun dato',
    error: 'Errore nella pagina. Riprova più tardi',
    networkError: 'Errore di rete'
  },
  List: {
    noMoreData: 'Nessun altro dato',
    networkError: 'Errore di rete',
    clickRetry: 'Riprova'
  },
  DateRangePicker: {
    startTime: 'Ora di inizio',
    endTime: 'Ora di fine',
    timeRange: 'Intervallo di tempo'
  }
};

export { itIT as default };
